import { render, staticRenderFns } from "./a-textarea.vue?vue&type=template&id=f3271c00&scoped=true&"
import script from "./a-textarea.vue?vue&type=script&lang=js&"
export * from "./a-textarea.vue?vue&type=script&lang=js&"
import style0 from "./a-textarea.vue?vue&type=style&index=0&id=f3271c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3271c00",
  null
  
)

export default component.exports